<!-- Optwaves POS System -->
<app-main-layout *ngIf="showLayout">
  <router-outlet></router-outlet>
</app-main-layout>
<router-outlet *ngIf="!showLayout"></router-outlet>